import { useState, useEffect } from 'react';
import './SportsEvent.css';
import sportsPic1 from '../sports/bcasports (1).webp'
import sportsPic2 from '../sports/bcasports (1).webp'
import sportsPic3 from '../sports/sportseve (2).jpeg'
import sportsPic19 from '../sports/bcasports (2).webp'
import sportsPic4 from '../sports/sportseve (1).jpeg'
import sportsPic20 from '../sports/bcasports (3).webp'
import sportsPic5 from '../sports/bcasports (4).webp'
import sportsPic21 from '../sports/bcasports (4).webp'
import sportsPic6 from '../sports/bcasports (5).webp'
import sportsPic7 from '../sports/bcasports (6).webp'
import sportsPic8 from '../sports/bcasports (7).webp'
import sportsPic9 from '../sports/bcasports (8).webp'
import sportsPic10 from '../sports/bcasports (9).webp'
import sportsPic11 from '../sports/bcasports (10).webp'
import sportsPic12 from '../sports/bcasports (11).webp'
import sportsPic13 from '../sports/bcasports (12).webp'
import sportsPic14 from '../sports/bcasports (13).webp'
import sportsPic15 from '../sports/bcasports (14).webp'
import sportsPic16 from '../sports/bcasports (15).webp'
import sportsPic17 from '../sports/bcasports (16).webp'
import sportsPic18 from '../sports/bcasports (17).webp'
import sportsPic22 from '../sports/sportseve (3).jpeg'
import sportsPic23 from '../sports/sportseve (4).jpeg'
import sportsPic24 from '../sports/sportseve (5).jpeg'
import sportsPic25 from '../sports/sportseve.jpeg'

const SportsEventPage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [allImages, setAllImages] = useState([]);

  // Gallery images for Session 2024-25
  const galleryImages = [
    { id: 22, src: sportsPic22, alt: 'Sports Event 22' }, 
    { id: 23, src: sportsPic23, alt: 'Sports Event 23' }, 
    { id: 24, src: sportsPic24, alt: 'Sports Event 24' }, 
    { id: 25, src: sportsPic25, alt: 'Sports Event 25' }, 
    { id: 4, src: sportsPic4, alt: 'Sports Event 4' }, 
    { id: 3, src: sportsPic3, alt: 'Sports Event 3' },  
    { id: 2, src: sportsPic2, alt: 'Sports Event 2' },
    { id: 6, src: sportsPic6, alt: 'Sports Event 6' },
    { id: 8, src: sportsPic8, alt: 'Sports Event 8' },
    { id: 9, src: sportsPic9, alt: 'Sports Event 9' },
    { id: 14, src: sportsPic14, alt: 'Sports Event 14' },
    { id: 21, src: sportsPic21, alt: 'Sports Event 21' },
    { id: 18, src: sportsPic18, alt: 'Sports Event 18' },
    { id: 19, src: sportsPic19, alt: 'Sports Event 19' },
    { id: 20, src: sportsPic20, alt: 'Sports Event 20' },
    { id: 7, src: sportsPic7, alt: 'Sports Event 7' },
    { id: 17, src: sportsPic17, alt: 'Sports Event 17' },
    { id: 10, src: sportsPic10, alt: 'Sports Event 10' },
    { id: 11, src: sportsPic11, alt: 'Sports Event 11' },
    { id: 12, src: sportsPic12, alt: 'Sports Event 12' },
    { id: 13, src: sportsPic13, alt: 'Sports Event 13' },
    { id: 15, src: sportsPic15, alt: 'Sports Event 15' },
    { id: 16, src: sportsPic16, alt: 'Sports Event 16' },
    { id: 1, src: sportsPic1, alt: 'Sports Event 1' },
    { id: 5, src: sportsPic5, alt: 'Sports Event 5' },
    
  ];

  useEffect(() => {
    setAllImages(galleryImages);
  }, []);

  const handleImageClick = (imageSrc) => {
    const imageIndex = galleryImages.findIndex(image => image.src === imageSrc);
    setCurrentImageIndex(imageIndex);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentImageIndex === null) return;
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentImageIndex]);

  return (
    <>
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>SPORTS EVENT</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Sports Event</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="sports-container">
        {/* Title Section */}
        <div className="sports-title-section">
          <h2>SPORTS EVENT</h2>
          <div className="sports-title-underline"></div>
        </div>

        {/* Session Gallery */}
        <section className="sports-gallery-section">
          
          <div className="sports-gallery">
            {galleryImages.map((image, index) => (
              <div 
                key={image.id} 
                className={`sports-gallery-item ${index % 2 === 0 ? 'sports-left' : 'sports-right'}`}
                onClick={() => handleImageClick(image.src)}
              >
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {currentImageIndex !== null && (
        <div className="sports-modal show" onClick={(e) => {
          if (e.target.classList.contains('sports-modal')) {
            closeModal();
          }
        }}>
          <div className="sports-modal-wrapper">
            <button className="sports-modal-close" onClick={closeModal}>&times;</button>
            <button className="sports-modal-btn sports-modal-prev" onClick={prevImage}>❮</button>
            <img 
              className="sports-modal-image" 
              src={galleryImages[currentImageIndex].src} 
              alt={galleryImages[currentImageIndex].alt}
            />
            <button className="sports-modal-btn sports-modal-next" onClick={nextImage}>❯</button>
          </div>
        </div>
      )}
    </>
  );
};

export default SportsEventPage;